import {
  ListContextProvider,
  ResourceContextProvider,
  useList,
  useTranslate,
} from "ra-core";

import { TasksIterator } from "./TasksIterator";

type TaskListProps = {
  tasks: any[];
  title: string;
  showContact?: boolean;
  isOverdue?: boolean;
};

export const TaskListFilter = ({
  tasks,
  title,
  showContact,
  isOverdue = false,
}: TaskListProps) => {
  const translate = useTranslate();
  const listContext = useList({
    data: tasks,
    resource: "tasks",
    perPage: 5,
  });

  const { total } = listContext;

  if (!tasks?.length || !total) return null;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 mb-2">
        <p
          className="font-nd-mono text-[10px] tracking-[0.08em] uppercase"
          style={{
            color: isOverdue ? "var(--nd-accent)" : "var(--nd-text-disabled)",
          }}
        >
          {title}
        </p>
        {isOverdue && (
          <span
            className="font-nd-mono text-[9px] leading-none px-1.5 py-0.5 rounded-sm tabular-nums"
            style={{ background: "var(--nd-accent)", color: "white" }}
          >
            {tasks.length}
          </span>
        )}
      </div>
      <ResourceContextProvider value="tasks">
        <ListContextProvider value={listContext}>
          <TasksIterator showContact={showContact} />
        </ListContextProvider>
      </ResourceContextProvider>
      {total > listContext.perPage && (
        <div className="flex justify-center">
          <a
            href="#"
            onClick={(e) => {
              listContext.setPerPage(listContext.perPage + 10);
              e.preventDefault();
            }}
            className="text-sm underline hover:no-underline"
          >
            {translate("crm.common.load_more")}
          </a>
        </div>
      )}
    </div>
  );
};
